<template>
  <div class="container-404">
    <InfoCard>
      <template #action>
        <router-link to="/">
          <Button variant="default">
            {{ $t("На главную") }}
          </Button>
        </router-link>
      </template>
    </InfoCard>
  </div>
</template>
<script>
import Button from "@/shared/ui/button/Button.vue";
import InfoCard from "@/shared/ui/custom/card/InfoCard.vue";
export default {
  name: "NotFound",
  components: { Button, InfoCard },
};
</script>

<style scoped lang="scss">
.container-404 {
  @apply flex items-center justify-center w-full h-screen;
  background-color: #f6f6f6;
  text-align: center;
}
</style>
